
export default {
  name: 'EmptyLayout',
  mounted() {
    console.debug('Empty layout mounted');
  },
};
